import React, { useState, useCallback } from "react";
import Modal from "react-modal";
import Cropper from "react-easy-crop";
import { useDropzone } from "react-dropzone";
import getCroppedImg from "./utils/cropImage";
import { useNavigate } from "react-router-dom";
import apiClient from "../../../api/processing plant/axiosInstancePlant";

Modal.setAppElement("#root");

const ImageCropModal3 = ({
  isOpen,
  onClose,
  ppId,
  companyName,
  setImage,
  fileNumber,
  refreshComponent,
}) => {
  const navigate = useNavigate();
  const [imageSrc, setImageSrc] = useState(null);
  const [crop, setCrop] = useState({ x: 0, y: 0 });
  const [zoom, setZoom] = useState(1);
  const [croppedAreaPixels, setCroppedAreaPixels] = useState(null);

  const onCropComplete = useCallback((croppedArea, croppedAreaPixels) => {
    setCroppedAreaPixels(croppedAreaPixels);
  }, []);

  const onFileChange = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;

    const reader = new FileReader();
    reader.addEventListener("load", () => setImageSrc(reader.result));
    reader.readAsDataURL(file);
  };

  const onDrop = useCallback((acceptedFiles) => {
    const file = acceptedFiles[0];
    if (!file) return;

    const reader = new FileReader();
    reader.addEventListener("load", () => setImageSrc(reader.result));
    reader.readAsDataURL(file);
  }, []);

  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    onDrop,
    accept: { "image/*": [] },
    multiple: false,
  });

  const handleUpload = async () => {
    try {
      const croppedImage = await getCroppedImg(imageSrc, croppedAreaPixels);
      const blob = croppedImage;

      const filetype = blob.type || "image/jpeg";

      // Convert blob to base64
      const toBase64 = (blob) =>
        new Promise((resolve, reject) => {
          const reader = new FileReader();
          reader.readAsDataURL(blob); // this returns base64 with MIME type prefix
          reader.onloadend = () => resolve(reader.result);
          reader.onerror = reject;
        });

      const base64Image = await toBase64(blob);
      setImage(base64Image);

      try {
        const imageKey = `image${fileNumber}`; // e.g., image1, image2, etc.

        const submissionData = {
          userId: ppId,
          [imageKey]: base64Image, // dynamically assign image1, image2, ...
          companyName: companyName,
        };

        console.log("Submission Data:", submissionData);
        const response = await apiClient.post(
          "/processingplant",
          submissionData
        );
        //console.log("Form submitted successfully:", response.data);
        alert("Image uploaded successfully!");
        onClose();
        refreshComponent();
        //setTimeout(() => setSubmitted(false), 2000); // Reset submitted state
      } catch (error) {
        console.error("Error submitting form:", error);
      }
    } catch (err) {
      console.error("Upload failed:", err);
      alert("Upload failed");
    }
  };

  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={onClose}
      ariaHideApp={false}
      style={{
        overlay: {
          backgroundColor: "rgba(0, 0, 0, 0.7)",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          zIndex: 1000,
        },
        content: {
          position: "relative",
          inset: "auto",
          width: "600px",
          maxWidth: "95vw",
          maxHeight: "90vh",
          padding: "20px",
          borderRadius: "8px",
          boxShadow: "0 4px 15px rgba(0, 0, 0, 0.3)",
          background: "#fff",
          display: "flex",
          flexDirection: "column",
          justifyContent: "space-between",
        },
      }}
    >
      <h2
        style={{
          marginBottom: "10px",
          textAlign: "center",
          fontFamily: "Arial, sans-serif",
        }}
      >
        Crop Your Image
      </h2>

      {/* Dropzone */}
      <div
        {...getRootProps()}
        style={{
          border: "2px dashed #ccc",
          borderRadius: "4px",
          padding: "20px",
          textAlign: "center",
          marginBottom: "10px",
          background: isDragActive ? "#f0f8ff" : "#fafafa",
          cursor: "pointer",
          fontFamily: "Arial, sans-serif",
        }}
      >
        <input {...getInputProps()} />
        {isDragActive ? (
          <p>Drop the image here ...</p>
        ) : (
          <p>Drag & drop an image here, or click to select one</p>
        )}
      </div>

      {/* Cropper */}
      {imageSrc && (
        <>
          <div
            style={{
              position: "relative",
              width: "100%",
              height: "400px",
              background: "#333",
              borderRadius: "4px",
              marginBottom: "10px",
              overflow: "hidden",
            }}
          >
            <Cropper
              image={imageSrc}
              crop={crop}
              zoom={zoom}
              aspect={4 / 3}
              onCropChange={setCrop}
              onZoomChange={setZoom}
              onCropComplete={onCropComplete}
            />
          </div>

          <input
            type="range"
            min={1}
            max={3}
            step={0.1}
            value={zoom}
            onChange={(e) => setZoom(Number(e.target.value))}
            style={{ width: "100%", marginBottom: "10px" }}
          />
        </>
      )}

      {/* Action buttons */}
      <div style={{ display: "flex", justifyContent: "flex-end", gap: "10px" }}>
        <button
          onClick={onClose}
          style={{
            padding: "10px 20px",
            background: "#ccc",
            border: "none",
            borderRadius: "4px",
            cursor: "pointer",
            fontFamily: "Arial, sans-serif",
          }}
        >
          Cancel
        </button>
        <button
          onClick={handleUpload}
          style={{
            padding: "10px 20px",
            background: "#007bff",
            color: "#fff",
            border: "none",
            borderRadius: "4px",
            cursor: "pointer",
            fontFamily: "Arial, sans-serif",
          }}
          disabled={!imageSrc}
        >
          Upload Cropped Image
        </button>
      </div>
    </Modal>
  );
};

export default ImageCropModal3;
